import { Component, OnInit } from '@angular/core';
import { SubheaderService } from '../../../../../core/services/layout/subheader.service';
import { MensagensService } from 'max-ng-lib';
import { ConexaoService } from '../../../../../services/conexao.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'm-conexoes',
  templateUrl: './conexoes.component.html',
  styleUrls: ['./conexoes.component.scss'],
})
export class ConexoesComponent implements OnInit {

  modelo: any = [];
  ipExterno: any = {};
  ipExterno1: any = {};
  ipExterno2: any = {};
  ipInterno: any = {};

  constructor(
    public mensagens: MensagensService,
    public subheaderService: SubheaderService,
    public conexaoService: ConexaoService) {

    this.listarConexoes();
  }

  private listarConexoes() {
    this.conexaoService
      .listarConexoes()
      .subscribe((dados) => {
        if (dados) {
          this.modelo = dados;
          this.ipExterno = this.modelo.find(m => m.id === 'SERVER_EXTERNO') || {};
          this.ipExterno1 = this.modelo.find(m => m.id === 'SERVER_EXTERNO_1') || {};
          this.ipExterno2 = this.modelo.find(m => m.id === 'SERVER_EXTERNO_2') || {};
          this.ipInterno = this.modelo.find(m => m.id === 'SERVER_INTERNO') || {};
          this.modelo.id = 1;
        }
      });
  }

  ngOnInit() {

    this.subheaderService.setTitle('Conexões');
    this.subheaderService.setBreadcrumbs([
      { title: 'Conexões' }
    ]);
  }

  podeGravar = () => {

    if (!this.ipExternoValido()) {
      this.mensagens.exibaToastAlerta('O servidor externo 1 está incorreto!');
      return false;
    }

    if (!this.ipExterno1Valido()) {
      this.mensagens.exibaToastAlerta('O servidor externo 2 está incorreto!');
      return false;
    }

    if (!this.ipExterno2Valido()) {
      this.mensagens.exibaToastAlerta('O servidor externo 3 está incorreto!');
      return false;
    }

    if (!this.ipInternoValido()) {
      this.mensagens.exibaToastAlerta('O servidor interno está incorreto!');
      return false;
    }

    return true;
  }

  modeloCustomizado = () => {
    const entidade = [];

    this.ipExterno.id = 'SERVER_EXTERNO';
    entidade.push(this.ipExterno);

    this.ipExterno1.id = 'SERVER_EXTERNO_1';
    entidade.push(this.ipExterno1);

    this.ipExterno2.id = 'SERVER_EXTERNO_2';
    entidade.push(this.ipExterno2);

    this.ipInterno.id = 'SERVER_INTERNO';
    entidade.push(this.ipInterno);

    return entidade;
  };

  private ipInternoValido() {
    return (isNullOrUndefined(this.ipInterno.ip) && isNullOrUndefined(this.ipInterno.porta))
      || (this.ipInterno.ip && this.ipInterno.porta);
  }

  private ipExterno2Valido() {
    return (isNullOrUndefined(this.ipExterno2.ip) && isNullOrUndefined(this.ipExterno2.porta))
      || (this.ipExterno2.ip && this.ipExterno2.porta);
  }

  private ipExterno1Valido() {
    return (isNullOrUndefined(this.ipExterno1.ip) && isNullOrUndefined(this.ipExterno1.porta))
      || (this.ipExterno1.ip && this.ipExterno1.porta);
  }

  private ipExternoValido() {
    return (isNullOrUndefined(this.ipExterno.ip) && isNullOrUndefined(this.ipExterno.porta))
      || (this.ipExterno.ip && this.ipExterno.porta);
  }
}
